export default "__VITE_ASSET__CB6FhbZy__"